import type { SVGProps } from 'react'
interface SvgCheckProps extends SVGProps<SVGSVGElement> {
  size?: string | number
}

const SvgCheck = ({ size = '1em', ...props }: SvgCheckProps) => (
  <svg height={size} viewBox="0 0 18 18" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="check_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#check_svg__a)">
      <path d="M7.162 13.644 2.744 9.224l1.217-1.217 3.201 3.202 6.877-6.877 1.217 1.217z" />
    </g>
  </svg>
)
export default SvgCheck
